class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);


/**
 * ALÉNOR — exclusive desktop navigation accordion.
 * The open path is the active panel and its ancestors.
 * Expanding a separate group collapses the preceding group, including nested items.
 * Mobile menu-drawer retains its native slide-in / focus-trap navigation.
 */
(function alenorExclusiveHeaderAccordion() {
  const navSelector = 'nav.header__inline-menu';

  function closePanel(panel) {
    if (!panel.open) return;
    panel.querySelectorAll('details[open]').forEach(function (child) {
      child.open = false;
      const childSummary = child.querySelector(':scope > summary');
      if (childSummary) childSummary.setAttribute('aria-expanded', 'false');
    });
    panel.open = false;
    const summary = panel.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('toggle', function (event) {
    const current = event.target;
    if (!(current instanceof HTMLDetailsElement)) return;

    const navigation = current.closest(navSelector);
    if (!navigation) return;

    if (current.open) {
      navigation.querySelectorAll('details[open]').forEach(function (panel) {
        // Keep the active panel and all its parent panels open.
        if (panel === current || panel.contains(current)) return;
        closePanel(panel);
      });
      const summary = current.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    } else {
      // Prevent previously expanded children from reopening automatically.
      current.querySelectorAll('details[open]').forEach(closePanel);
    }

    // Keep the native Shopify header state in sync if two toggles fire together.
    const header = navigation.closest('.header-wrapper');
    if (header) {
      requestAnimationFrame(function () {
        header.preventHide = Boolean(navigation.querySelector('header-menu > details[open]'));
      });
    }
  }, true);
})();
